import React from 'react';

import Thumb from '../img/blogs/javascript.jpg';

const SomeJavaScriptProblemsSolution = {
    id: 20, permalink: "some-javascript-problems-solution", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 15, 2020", categories: "JavaScript", title: "Some JavaScript Problems Solution", shortDesc: "Here are some JavaScript Problems Solution.", fullDesc: <>
        <h2>Problem 1:</h2>
        <h4>Suppose, You have two <strong>variables</strong> called <code>a</code> and <code>b</code> and their values are respectively <code>"12"</code> and <code>18</code>. You have to <strong>sum</strong> them and the answer should be <code>30</code>.</h4>

        <h3>Solution:</h3>
        <p>According to your question:</p>
        <pre className="code">
            const a = "12"; <br />
            const b = 18;
        </pre>
        <p>Here <strong>variable</strong> a is <code>a</code> <strong>string</strong>. Firstly, I have to convert it to an <strong>Integer Number</strong>, then I can <strong>sum</strong> between them. Because string can't <strong>sum</strong>, this can <strong>concatenation</strong>.</p>

        <pre className="code">
            const a = "12"; <br />
            const b = 18; <br /><br />

            const c = parseInt(a); <br />
            console.log(c + b); <br />
        </pre>
        <p><strong>Expected output:</strong> <code className="output">30</code></p>


        <h2>Problem 2:</h2>
        <h4>Similar to "<strong>Problem 1</strong>", you have two <strong>variables</strong> called <code>a</code> and <code>b</code> and their values are respectively <code>"11.6"</code> and <code>18.4</code>. You have to <strong>sum</strong> them and the answer should be <code>30</code>.</h4>

        <h3>Solution:</h3>
        <p>Here I will use <code>parseFloat()</code> instead of <code>parseInt()</code>. Because <code>parseInt()</code> will return <code>"11.6"</code> to <code>11</code>. For this, the <strong>sum</strong> will be different. But <code>parseFloat()</code> will return <code>"11.6"</code> to <code>11.6</code>.</p>

        <pre className="code">
            const a = "11.6"; <br />
            const b = 18.4; <br /><br />

            const c = parseFloat(a); <br />
            console.log(c + b);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">30</code></p>


        <h2>Problem 3:</h2>
        <h4>Suppose, you have a <strong>rectangle</strong>. And this <strong>rectangle length</strong> is <code>12</code> and the <strong>width</strong> is <code>6.5</code>. You have to calculate the area of the <strong>rectangle</strong>. The answer should be: <code>78</code></h4>

        <h3>Solution:</h3>
        <pre className="code">
            const getArea = (length, width) => length * width; <br />
            console.log(getArea(12, 6.5));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">78</code></p>


        <h2>Problem 4:</h2>
        <h4>Implement a <strong>function</strong> named <code>factorial</code> that has one parameter: <code>n</code>. It must return the value of <code>n!</code> or <code>n</code> <strong>factorial</strong>.</h4>

        <h3>Solution:</h3>
        <pre className="code">
            const factorial = n => &#123; <br />
                &nbsp; let ans = 1; <br /><br />

                &nbsp; for (let i = 2; i &lt;= n; i++) ans = ans * i; <br />
                &nbsp; return ans; <br />
            &#125; <br />
            console.log(factorial(4));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">24</code></p>


        <h2>Problem 5:</h2>
        <h4>Create a <strong>function</strong> that returns the <strong>area</strong> and <strong>perimeter</strong> of a <strong>circle</strong>. The <strong>function</strong> has one parameter: <code>r</code> (circle radius). The answer should be <code>Circle area: <em>value</em></code> and <code>Circle perimeter: <em>value</em></code>.</h4>

        <h3>Solution:</h3>
        <pre className="code">
            const circleAreaParameter = r => &#123; <br />
                &nbsp; const PI = Math.PI; <br /><br />

                &nbsp; const area = PI * (r * r) <br />
                &nbsp; console.log("Circle area: " + area); <br /><br />

                &nbsp; const perimeter = 2 * PI * r; <br />
                &nbsp; console.log("Circle perimeter: " + perimeter); <br />
            &#125; <br />
            circleAreaParameter(2.6);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Circle area: 21.237166338267002</code> and <code className="output">Circle perimeter: 16.336281798666924</code></p>


        <h2>Problem 6:</h2>
        <h4>Create a <strong>Grading</strong> system using the <code>if-else</code> condition in your own way. But, there should at least <code>A, B, C, and F</code> grades in your condition.</h4>

        <h3>Solution:</h3>
        <pre className="code">
            const getGrade = score => &#123; <br />
                &nbsp; let grade; <br />
                &nbsp; if (80 &lt;= score) grade = "A+"; <br />
                &nbsp; if (70 &lt;= score &amp;&amp; score &lt; 80) grade = "A"; <br />
                &nbsp; if (60 &lt;= score &amp;&amp; score &lt; 70) grade = "A-"; <br />
                &nbsp; if (50 &lt;= score &amp;&amp; score &lt; 60) grade = "B"; <br />
                &nbsp; if (40 &lt;= score &amp;&amp; score &lt; 50) grade = "C"; <br />
                &nbsp; if (33 &lt;= score &amp;&amp; score &lt; 40) grade = "D"; <br />
                &nbsp; if (0 &lt;= score &amp;&amp; score &lt; 33) grade = "F"; <br />
                &nbsp; return grade; <br />
            &#125; <br />
            console.log("Your Grade is: " + getGrade(50));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Your Grade is: B</code></p>


        <h2>Problem 7:</h2>
        <h4>Create a Switch statement and show the current day (i.e. Saturday, Sunday, .......)</h4>

        <h3>Solution:</h3>
        <pre className="code">
            let day; <br />
            switch (new Date().getDay()) &#123; <br />
                &nbsp; case 0: <br />
                    &nbsp;   day = "Sunday"; <br />
                    &nbsp;   break; <br />
                &nbsp; case 1: <br />
                    &nbsp;   day = "Monday"; <br />
                    &nbsp;   break; <br />
                &nbsp; case 2: <br />
                    &nbsp;   day = "Tuesday"; <br />
                    &nbsp;   break; <br />
                &nbsp; case 3: <br />
                    &nbsp;   day = "Wednesday"; <br />
                    &nbsp;   break; <br />
                &nbsp; case 4: <br />
                    &nbsp;   day = "Thursday"; <br />
                    &nbsp;   break; <br />
                &nbsp; case 5: <br />
                    &nbsp;   day = "Friday"; <br />
                    &nbsp;   break; <br />
                &nbsp; case 6: <br />
                    &nbsp;   day = "Saturday"; <br />
                    &nbsp;   break; <br />
            &#125; <br />
            console.log("Today is " + day);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Today is <em>Day(Saturday or Sunday or .......)</em></code></p>


        <h2>Problem 8:</h2>
        <h4>Create a function that will return the <strong>second largest number</strong> from an <strong>array</strong>. Use <code>[7, 3, 6, 7, 4, 1]</code> <strong>array</strong>, the answer should be <code>6</code>.</h4>

        <h3>Solution:</h3>
        <pre className="code">
            const getSecondLargest = (nums) => &#123; <br />
                &nbsp; const max = Math.max(...nums); <br />
                &nbsp; nums = nums.filter(num => num !== max); <br />
                &nbsp; return Math.max(...nums); <br />
            &#125;; <br />
            numsArr = [7, 3, 6, 7, 4, 1] <br />
            console.log(getSecondLargest(numsArr));
        </pre>
        <p><strong>Expected output:</strong><code className="output">6</code></p>


        <h2>Problem 9:</h2>
        <h4>Create a <strong>Person class</strong>. This should return the <code>name</code> and <code>age</code> of a person.</h4>

        <h3>Solution:</h3>
        <pre className="code">
            class Person &#123; <br />
                &nbsp; constructor(name, age) &#123; <br />
                    &nbsp;   this.name = name; <br />
                    &nbsp;   this.age = age; <br />
                &nbsp; &#125; <br />
            &#125; <br />
            const mySelf = new Person("Wasek Bellah", 21); <br />
            console.log("My name is " + mySelf.name + ". I am " + mySelf.age + " years old.");
        </pre>
        <p><strong>Expected output:</strong><code className="output">My name is Wasek Bellah. I am 21 years old.</code></p>


        <h2>Problem 10:</h2>
        <h4>Suppose, you have a string <code>"HelloWorld"</code>. And you have to loop every character. First, you have to print each vowel in a new line, then print each consonant in a new line. The answer should be:</h4>
        <pre className="code">
            e <br />
            o <br />
            o <br />
            H <br />
            l <br />
            l <br />
            W <br />
            r <br />
            l <br />
            d
        </pre>

        <h3>Solution:</h3>
        <pre className="code">
            const vowelsAndConsonants = s => &#123; <br />
                &nbsp; let strVowels = ""; <br />
                &nbsp; let strConsonants = ""; <br />
                &nbsp; let i = 0; <br /><br />

                &nbsp; for (i in s) &#123; <br />
                    &nbsp;   if (s.charAt(i) == "a" || s.charAt(i) == "e" || s.charAt(i) == "i" || s.charAt(i) == "o" || s.charAt(i) == "u") &#123; <br />
                        &nbsp;     strVowels += s.charAt(i); <br />
                    &nbsp;   &#125; else if (s.charAt(i) != "a" || s.charAt(i) != "e" || s.charAt(i) != "i" || s.charAt(i) != "o" || s.charAt(i) != "u") &#123; <br />
                            &nbsp;     strConsonants += s.charAt(i); <br />
                    &nbsp;   &#125; <br />
                &nbsp; &#125; <br />
                &nbsp; for (i in strVowels) console.log(strVowels.charAt(i)); <br />
                &nbsp; for (i in strConsonants) console.log(strConsonants.charAt(i)); <br />
            &#125; <br />
            vowelsAndConsonants("HelloWorld");
        </pre>
        <p><strong>Expected output:</strong> <br /><code className="output" style={{ marginLeft: "150px" }}>
            e <br />
            o <br />
            o <br />
            H <br />
            l <br />
            l <br />
            W <br />
            r <br />
            l <br />
            d
        </code>
        </p>
    </>
};

export default SomeJavaScriptProblemsSolution;